<template>
  <div v-if="form" class="report-template">
    <div class="md-layout items-center">
      <!--    GENERAL INFO-->
      <div class="md-layout-item md-size-100 overflow-auto mt-3">
        <table class="table-info-student w-full">
          <tr class="table-header">
            <th>
              <span>Student name</span>
              <span :class="generateVietnamese">Tên học sinh</span>
            </th>
            <th>
              <span>Student ID</span>
              <span :class="generateVietnamese">Mã học sinh</span>
            </th>
            <th>
              <span>Grade</span>
              <span :class="generateVietnamese">Khối học </span>
            </th>
            <th>
              <span>Program</span>
              <span :class="generateVietnamese">Chương trình</span>
            </th>
          </tr>
          <tr>
            <td>
              {{ formProps.student && formProps.student.full_name }}
            </td>
            <td>
              {{ formProps.student && formProps.student.student_code }}
            </td>
            <td>
              {{ formProps.student && formProps.student.grade }}
            </td>
            <td>
              {{ formProps.program && formProps.program.name }}
            </td>
          </tr>
        </table>
      </div>

      <!-- ATTENDANCE - CURRENT GRADE-->
      <div class="md-layout-item md-size-100 mt-6" v-if="reportType">
        <p class="text-[16px] font-medium label-index uppercase">
          I. ATTENDANCE -
          {{ label[reportType].english }}
        </p>
        <span class="pl-2" :class="generateVietnamese">
          Điểm danh -
          {{ label[reportType].vietnamese }}
        </span>

        <p class="font-medium pt-2">* Attendance</p>
        <span class="pl-2" :class="generateVietnamese">Điểm danh</span>
        <table class="table-attendance w-full mt-2">
          <tr class="table-header">
            <th>
              <span>Instructional days</span>
              <span :class="generateVietnamese">Tổng số ngày đã học</span>
            </th>
            <th>
              <span>Presence</span>
              <span :class="generateVietnamese">Số ngày đi học</span>
            </th>
            <th>
              <span>Excused absence</span>
              <span :class="generateVietnamese">Ngày vắng mặt có phép</span>
            </th>
            <th>
              <span>Unexcused absence</span>
              <span :class="generateVietnamese">Ngày vắng mặt không phép</span>
            </th>
            <th>
              <span>Excused tardy</span>
              <span :class="generateVietnamese">Ngày muộn có phép</span>
            </th>
            <th>
              <span>Unexcused tardy</span>
              <span :class="generateVietnamese">Ngày muộn không phép</span>
            </th>
          </tr>
          <tr>
            <td>
              <input
                v-model="form.school_attendance.number_of_session"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
            <td>
              <input
                v-model="form.school_attendance.days_present"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
            <td>
              <input
                v-model="form.school_attendance.days_excused_absence"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
            <td>
              <input
                v-model="form.school_attendance.days_unexcused_absence"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
            <td>
              <input
                v-model="form.school_attendance.days_excused_tardy"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
            <td>
              <input
                v-model="form.school_attendance.days_unexcused_tardy"
                :disabled="isDisable || isViewOnly"
                class="text-center min-w-[60px]"
                type="number"
              />
            </td>
          </tr>
        </table>

        <p class="font-medium mt-4">* {{ labelScoreTable.english }}</p>
        <span class="pl-2" :class="generateVietnamese">
          {{ labelScoreTable.vietnamese }}
        </span>
        <div class="mt-2">
          <table
            v-if="form.learning_progress && form.learning_progress.length"
            class="w-full"
          >
            <tr class="table-header">
              <th>
                <span>Class</span>
                <span :class="generateVietnamese">Lớp học</span>
              </th>
              <th>
                <span>Subject</span>
                <span :class="generateVietnamese">Môn học</span>
              </th>
              <th>
                <span>{{ labelScoreTable.english }}(%)</span>
                <span :class="generateVietnamese">{{
                  labelScoreTable.vietnamese
                }}</span>
              </th>
              <th>
                <span>Letter grade</span>
                <span :class="generateVietnamese">Điểm số bằng chữ</span>
              </th>
            </tr>
            <tr
              v-for="(item, index) in form.learning_progress"
              :key="'learning progress' + index"
              class="border-x-[#ccc] border-2"
            >
              <td>{{ item.class_name }}</td>
              <td>{{ item.subject }}</td>
              <td>
                <input
                  v-model="item.current_score"
                  :disabled="isDisable"
                  class="text-center"
                  type="number"
                />
              </td>
              <td>
                <input
                  v-model="item.scalling"
                  :disabled="isDisable"
                  class="text-center"
                  type="text"
                />
              </td>
            </tr>
          </table>
        </div>

        <!--        TODO: temporarily hidden -->
        <!--        <div v-if="reportType === ReportTypes.EndOfTwo">
                  <p class="font-medium mt-4">
                    * Grade level placement:
                  </p>
                  <span class="pl-2" :class="generateVietnamese">
                    Tổng kết năm học
                  </span>
                  <div
                    class="mt-2"
                    v-if="
                      form.grade_level_placement && form.grade_level_placement.length
                    "
                  >
                    <table class="w-full">
                      <tr class="table-header">
                        <th>
                          <span>Subject</span>
                          <span :class="generateVietnamese">Môn học</span>
                        </th>
                        <th>
                          <span>Semester 1 - Letter grade</span>
                          <span :class="generateVietnamese">Điểm cuối kỳ 1</span>
                        </th>
                        <th>
                          <span>Semester 2 - Letter grade</span>
                          <span :class="generateVietnamese">Điểm cuối kỳ 2</span>
                        </th>
                        <th>
                          <span>Overall assessment</span>
                          <span :class="generateVietnamese"
                            >Kết quả học tập cả năm</span
                          >
                        </th>
                      </tr>
                      <tr
                        v-for="(subject, index) in form.grade_level_placement"
                        :key="'grade level placement' + index"
                        class="border-x-[#ccc] border-2"
                      >
                        <td>{{ subject.subject_name }}</td>
                        <td>{{ subject.scalling_semester_1 }}</td>
                        <td>{{ subject.scalling_semester_2 }}</td>
                        <td>{{ subject.is_passed ? "Pass" : "Fail" }}</td>
                      </tr>
                    </table>
                  </div>
                </div>-->
      </div>

      <!--      LEARNING BEHAVIOR-->
      <div class="md-layout-item md-size-100 mt-6">
        <p class="text-[16px] font-medium label-index">
          II. LEARNING BEHAVIORS
        </p>
        <span class="pl-2" :class="generateVietnamese"
          >Đánh giá học tập trong lớp</span
        >

        <p class="font-medium mt-2 pl-2">
          1 - Need Practice, 2 - Satisfactory, 3 - Outstanding
        </p>
        <span class="pl-2" :class="generateVietnamese">
          1 - Cần cố gắng, 2 - Đạt yêu cầu, 3 - Xuất sắc
        </span>

        <md-table class="mt-3">
          <md-table-row class="table-header">
            <th>
              <span>
                Learning behaviors
              </span>
              <span :class="generateVietnamese">Đánh giá học tập trên lớp</span>
            </th>
            <th v-if="firstTeacher">
              <span>{{ firstTeacher }}</span>
            </th>
            <th v-if="secondTeacher">
              <span>{{ secondTeacher }}</span>
            </th>
          </md-table-row>
          <md-table-row
            v-for="(item, index) in learningBehaviors"
            :key="'table' + index"
            class="border-x-[#ccc] border-2"
          >
            <md-table-cell>
              <div class="text-left font-medium">
                {{ item.name }}
                <span :class="generateVietnamese">{{
                  item.text_vietnamese
                }}</span>
              </div>
            </md-table-cell>
            <md-table-cell v-if="firstTeacher">
              <select
                v-model="item.first_teacher"
                :disabled="isDisable || isViewOnly"
                class="underline w-[40px]"
              >
                <option
                  v-for="(option, idx) in optionsScale"
                  :key="'option-left-col' + idx"
                  :value="option"
                  >{{ option }}
                </option>
              </select>
            </md-table-cell>
            <md-table-cell v-if="secondTeacher"
              ><select
                v-model="item.second_teacher"
                :disabled="isDisable || isViewOnly"
                class="underline w-[40px]"
              >
                <option
                  v-for="(option, idx) in optionsScale"
                  :key="'option-left-col' + idx"
                  :value="option"
                  >{{ option }}
                </option>
              </select></md-table-cell
            >
          </md-table-row>
        </md-table>
      </div>

      <!--      TEACHER COMMENT-->
      <div class="md-layout-item md-size-100 mt-6 table-teacher-comment">
        <p class="text-[16px] font-medium label-index">
          III. TEACHER COMMENTS
        </p>
        <span class="pl-2" :class="generateVietnamese"
          >Nhận xét của giáo viên</span
        >

        <md-table class="mt-3" v-if="form.comment && form.comment.length">
          <tr
            v-for="(item, index) in form.comment"
            :key="'learning progress' + index"
            class="teacher-comment-table"
          >
            <td class="w-[40%] font-medium">{{ item.name }}</td>
            <td class="align-bottom">
              <p v-if="isDisable || isViewOnly" class="text-left text-[#000]">
                {{ item.value }}
              </p>
              <md-field v-else class="field-comment m-0">
                <md-textarea
                  v-model="item.value"
                  :placeholder="$t('smi_sri.comment')"
                  class="max-h-[150px] min-h-[36px]"
                  md-autogrow
                ></md-textarea>
              </md-field>
            </td>
          </tr>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getClassStatus,
  learningBehaviors,
  setContentSendBtn,
  STATUS
} from "@/pages/ProgressReport/Components/utils";
import { service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import { generateStatusReport } from "@/helpers/text-helper";
import pick from "lodash/pick";
import { ReportTypes } from "../../../../constants/Report";

const optionsScale = [1, 2, 3];
export default {
  name: "template-progress-report",
  components: {},
  props: [
    "formProps",
    "termId",
    "isViewOnly",
    "isDisable",
    "reportTemplate",
    "generateVietnamese"
  ],
  data() {
    return {
      isShowComponent: false,
      ReportTypes,
      learningBehaviors: learningBehaviors(),
      setContentSendBtn,
      convertDateFromServer,
      getClassStatus,
      generateStatusReport,
      STATUS,
      optionsScale,
      form: null,
      termSelect: {
        value: "",
        options: []
      },
      messageErrors: {
        termId: "",
        reportType: "",
        rateRequired: "",
        commentRequired: ""
      },
      label: {
        monthly_report: {
          english: "Current grade",
          vietnamese: "Điểm số hiện tại"
        },
        mid_term: {
          english: "Current grade",
          vietnamese: "Điểm số hiện tại"
        },
        end_of_semester_report: {
          english: "Final grade",
          vietnamese: "Điểm cuối kỳ"
        },
        end_of_semester_1: {
          english: "Final grade",
          vietnamese: "Điểm cuối kỳ"
        },
        end_of_semester_2: {
          english: "Final grade", // - Grade level placement
          vietnamese: "Điểm cuối kỳ" // - Tổng kết năm học
        }
      }
    };
  },
  computed: {
    firstTeacher() {
      return this.formProps?.review_content?.first_teacher[0]?.name_teacher;
    },
    secondTeacher() {
      return this.formProps?.review_content?.second_teacher[0]?.name_teacher;
    },
    studentId() {
      return this.formProps.student_id;
    },
    programId() {
      return this.formProps.program_id;
    },
    progressId() {
      return getId(this.formProps) || this.$route.params.id;
    },
    reportType() {
      return this.formProps.report_type;
    },
    labelScoreTable() {
      return this.reportType === ReportTypes.MidTerm
        ? this.label.mid_term
        : this.label.end_of_semester_1;
    }
  },
  watch: {
    formProps() {
      this.setForm(this.formProps);
    },
    termId(newTerm) {
      if (newTerm !== this.formProps.term_id) {
        this.getClassOfTerm();
      }
    }
  },
  methods: {
    roundingScore(score) {
      if (!score) return "";
      return (+score).toFixed(2);
    },

    setForm(dataDetail) {
      let keys = [
        "comment",
        "review_content",
        "status",
        "school_attendance",
        "learning_progress",
        "grade_level_placement",
        "type_sending_model",
        "title",
        "term_id",
        "report_type",
        "reviewer_verification"
      ];
      this.form = pick(dataDetail, keys);
      this.form.review_content = dataDetail.review_content
        ? this.mapReviewContent(dataDetail.review_content)
        : undefined;
    },

    mapReviewContent(reviewContent) {
      return this.learningBehaviors.forEach(item => {
        item.first_teacher =
          (reviewContent.first_teacher &&
            reviewContent.first_teacher.find(
              teacher => teacher.name === item.key
            )?.value) ||
          "";
        item.second_teacher =
          (reviewContent.second_teacher &&
            reviewContent.second_teacher.find(
              teacher => teacher.name === item.key
            )?.value) ||
          "";
      });
    },

    buildFormSave(reportValidate) {
      return {
        ...this.form,
        report_type: this.reportType,
        term_id: this.termId,
        report_validate: reportValidate,
        review_content: {
          first_teacher: this.learningBehaviors.map(item => ({
            name: item.key,
            value: item.first_teacher,
            name_teacher: this.firstTeacher
          })),
          second_teacher: this.secondTeacher
            ? this.learningBehaviors.map(item => ({
                name: item.key,
                value: item.second_teacher,
                name_teacher: this.secondTeacher
              }))
            : []
        }
      };
    },

    checkValidateForm() {
      this.messageErrors = {
        rateRequired:
          this.learningBehaviors.some(
            item =>
              (this.firstTeacher && !item.first_teacher) ||
              (this.secondTeacher && !item.second_teacher)
          ) && "rate_required"
      };
      Object.values(this.messageErrors).forEach(item => {
        if (item) Message.error(this.$t(`progress_report.${item}`));
      });
      return Object.values(this.messageErrors).every(item => !item);
    },

    async getClassOfTerm() {
      const params = {
        report_type: this.reportType,
        term_id: this.termId,
        student_id: this.studentId,
        program_id: this.programId,
        progress_id: this.progressId
      };
      const { data } = await this.$axios.get(
        `${service_names.user}/progress/attendances`,
        params
      );
      this.form.school_attendance = data.school_attendance;
      this.form.learning_progress = data.classes.map(item => {
        return {
          ...item,
          current_score: this.roundingScore(item.current_score)
        };
      });
      this.form.grade_level_placement = data.grade_level_placement;
      this.form.comment = data.classes.map(item => {
        return {
          name: item.subject,
          value: this.formProps.comment.length
            ? this.formProps.comment.find(data => data.name === item.subject)
                .value
            : ""
        };
      });
    }
  },
  created() {
    if (this.formProps) this.setForm(this.formProps);
  }
};
</script>
<style lang="scss">
.report-template {
  --main-col-background: #891d1c;
  --main-col-text: #fff;

  input {
    width: 45px;
    border: 0;
    outline: 0;
    background: transparent;
    border-bottom: 1px solid #ccc;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .label-index,
  .teacher-comment-table td {
    color: var(--main-col-background);
  }

  .table-header {
    background: var(--main-col-background);
    color: var(--main-col-text);
  }

  .table-teacher-comment {
    .md-table-cell {
      padding: 5px 10px !important;
    }
  }

  .md-table-head-label {
    padding-right: 0 !important;
  }

  th,
  td {
    text-align: center !important;
    border: 1px solid #ccc;
    min-width: 30px !important;
    padding: 5px;
  }

  th {
    span {
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
